import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { Assignment } from 'src/app/classes/assignment';
import { AssignmentService } from 'src/app/services/assignment.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {
  fa = fa;
  assignment: Assignment = new Assignment()
  aiQuery = '';

  constructor(
    private route: ActivatedRoute,
    private assigmentService: AssignmentService
  ) {}  

  ngOnInit(): void {
    this.assigmentService.initSocket()

    this.assigmentService.listen().subscribe((update) => {
      
      if(update.type == 'assignment') {
        this.assigmentService.picture(this.assignment.uuid).subscribe((picture) => {
          this.assignment.picture = picture.url;
          this.assignment.updating = false
        })
      }

      if(update.type == 'product') { 
        const product = this.assignment.products.find(p => p.product.uuid == update.uuid)
        
        this.assigmentService.productPicture(update.uuid).subscribe((picture) => {
          if(product) {
            product.product.picture = picture.url;
            product.product.updating = false
          }
        })
      }
    })

    this.assigmentService.get(this.route.snapshot.params['categoryId']).subscribe(assignment => {
      this.assignment = assignment;
    })
  }

  onAiSubmit(): void {
    if (!this.aiQuery.trim()) return;
    this.picturesUpdating(true)
    
    this.assigmentService.update(this.assignment.uuid, this.aiQuery).subscribe(() => {
      
    })
    this.aiQuery = '';
  }

  get productImageCount(): number {
    return this.assignment?.products?.length ?? 0;
  }

  /** Wider hero on large screens when many thumbnails need horizontal room */
  get mosaicHeroWide(): boolean {
    return this.productImageCount >= 7;
  }

  picturesUpdating(updating: boolean): void {
    this.assignment.updating = updating;
    this.assignment.products.forEach(product => {
      product.product.updating = updating;
    });
  }
}
